<div class="container pt-100">
	<div class="row mt-50">

		<div class="col order-xl-1 col-xl-8 order-lg-1 col-lg-8 order-md-2 col-md-12 order-sm-2 col-sm-12 order-2 col-xs-12 col-12">
			<div class="ui-block">

				<!-- Single Post -->

				<article class="hentry blog-post single-post single-post-v3">
					<div class="post-content-wrap">
						<div class="post-content post-description">
							<ng-container *ngIf="!description">
								<div class="animated">
									<h1 class="title-preloader noselect" [innerHTML]="preloader.title"></h1>
									<div class="desc-preloader noselect" [innerHTML]="preloader.description"></div>
								</div>
							</ng-container>

							<ng-container *ngIf="description">
								<h1 class="stunning-header-title"><strong>{{curentEvent?.name}}</strong></h1>
								<div class="text-justify" [innerHTML]="description | translatedDescription"></div>
							</ng-container>
						</div>
					</div>
				</article>

				<!-- ... end Single Post -->

			</div>
		</div>

		<div class="col order-xl-2 col-xl-4 order-lg-2 col-lg-4 order-md-1 col-md-12 order-sm-1 col-sm-12 order-1 col-xs-12 col-12 mb-4">
			<aside class="blog-post-wrap">
				<div class="post-thumb">
					<img [src]="curentEvent?.imageCover" alt="author">
				</div>
				<div class="ui-block p-4">

					<!-- Post -->

					<div class="event-info-item">
						<div *ngIf="false" class="price"> {{curentEvent?.price == '0' ? 'Gratuit':'$ '+ curentEvent?.price}}</div>
					</div>

					<div class="event-info-item">
						<div class="event-info-item-title">
							<i class="far fa-calendar-alt"></i>
							<div class="ml-10">{{'START_DATE' | translate}}</div>
						</div>
						<div>{{convertDate(curentEvent?.startingDate)}}</div>
					</div>

					<div class="event-info-item">
						<div class="event-info-item-title">
							<i class="far fa-calendar-alt"></i>
							<div class="ml-10">{{'END_DATE' | translate}}</div>
						</div>
						<div>{{convertDate(curentEvent?.endDate)}}</div>
					</div>

					<div class="event-info-item">
						<div class="event-info-item-title">
							<i class="fas fa-map-marker-alt"></i>
							<div class="ml-10">{{'LOCATION' | translate}}</div>
						</div>
						<div>{{curentEvent?.location}}</div>
					</div>

					<a (click)="opensubscriptionForm()"
						class="btn btn-primary btn-lg full-width cursor-pointer mt-3 mb-0">{{'INSCRIPTION' | translate}}<div
							class="ripple-container"></div></a>

					<!-- ... end Post -->

				</div>

			</aside>
		</div>

	</div>

</div>